/*
  Storefront display preferences only.
  Owns timezone control hydration outside Cart runtime.
  Does not mutate Cart, prices, currency, checkout, customer data or GFun.
*/
(function storefrontLocalizationRuntime(window, document) {
  'use strict';

  var SELECTOR = '[data-cart-timezone-select]';
  var STORAGE_KEY = 'littleg_display_timezone';
  var DEFAULT_TIMEZONE = 'Asia/Hong_Kong';

  function read() {
    try { return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_TIMEZONE; }
    catch (_) { return DEFAULT_TIMEZONE; }
  }

  function write(timezone) {
    var value = String(timezone || DEFAULT_TIMEZONE);
    try { window.localStorage.setItem(STORAGE_KEY, value); } catch (_) {}
    return value;
  }

  function hydrate(root) {
    var timezone = read();
    Array.prototype.slice.call((root || document).querySelectorAll(SELECTOR)).forEach(function (select) {
      var supported = Array.prototype.some.call(select.options || [], function (option) {
        return option.value === timezone;
      });
      select.value = supported ? timezone : DEFAULT_TIMEZONE;
    });
    return timezone;
  }

  function publish(timezone, source) {
    var detail = { timezone: timezone, source: source || 'storefront-localization.js' };
    document.dispatchEvent(new CustomEvent('storefront:timezone-change', { detail: detail }));
  }

  document.addEventListener('change', function (event) {
    var select = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!select) return;
    var timezone = write(select.value);
    hydrate(document);
    publish(timezone, 'timezone-select');
  });

  document.addEventListener('shopify:section:load', function (event) {
    hydrate(event && event.target ? event.target : document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(document); }, { once: true });
  } else {
    hydrate(document);
  }

  window.StorefrontLocalization = Object.assign(window.StorefrontLocalization || {}, {
    getTimezone: read,
    setTimezone: function (timezone) {
      var value = write(timezone);
      hydrate(document);
      publish(value, 'api');
      return value;
    },
    hydrate: hydrate
  });
})(window, document);
